import { Link } from 'react-router';
import PaymentButton from '../Components/PaymentButton';

export default function Pricing() {
    return (
        <div className="p-8 ">
            <Link to='/'>
                <button className="mt-2 ml-2 cursor-pointer px-5 py-1 bg-zinc-800 hover:bg-zinc-700 rounded-2xl">
                    ←
                </button>
            </Link>
            <h2 className=' flex justify-center text-xl font-medium text-green-500'>Choose Your Plan</h2>

            {/* <div className="grid grid-cols-3 gap-6"> */}
            <div className='flex justify-center'>
                {/* Basic Plan */}
                <div className="bg-zinc-900 p-8 w-1/3 mt-5 rounded-3xl">
                    <h1 className='text-xl text-purple-400'>Basic</h1>
                    <p className="text-4xl font-bold mb-5">₹499/month</p>
                    <PaymentButton
                        amount={499}
                        planName="Basic Monthly"
                        onSuccess={(res) => {
                            console.log("Payment Done", res);
                            // Redirect or update UI
                        }}
                    />
                </div>

                {/* Pro Plan */}
                {/* <div className="bg-zinc-900 p-8 rounded-3xl border-2 border-violet-500">
                    <h3>Pro</h3>
                    <p className="text-4xl font-bold">₹999/month</p>
                    <PaymentButton 
                        amount={999} 
                        planName="Pro Monthly" 
                        onSuccess={(res) => alert("Pro Plan Activated!")} 
                    />
                </div> */}
            </div>
        </div>
    );
}